export const ACCEPT_CONFIG = {
    image: ['.png', '.jpg', '.jpeg', '.gif', '.bmp','bmp','wmf','emf','tif','tiff','ico','psd'],
    video: ['.mp4', '.rmvb', '.mkv', '.wmv', '.flv','MID','.avi','.mov','wmv','.rm','mpg','mpeg','swf','asf','3gp','vob','dat','swf'],
    audio: ['.mp3', '.wav', '.wma', '.ogg', '.aac', '.flac','ape','flac','mid','au','wv'],
    // doc: ['.doc','.docx'],
    document: ['.doc','.docx','.xls', '.xlsx', '.ppt', '.pptx', '.pdf', '.txt', '.tif', '.tiff','.rar','.wps','rtf','ini','xml','htm','html','css','js',
      'zip','rar','iso','cab','7z','gz','tar','jar','ace','bz2','z'],
    getAll(){
        return [...this.image, ...this.video, ...this.document, ...this.audio]
    },
};



// WEBPACK FOOTER //
// ./src/components/VueSimpleUploader/js/config.js